import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Login } from '@/components/HankoAuth';
import { Logo } from '@/components/Logo';

export default function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleLogin = () => {
    navigate('/', { replace: true });
  };

  return (
    <>
      <div className="md:flex">
        <div className="m-auto min-h-100vh flex items-center justify-center flex-col w-full bg-grey-100">
          <div className="shadow-md rounded-14-0 max-w-[480px] w-full p-2-0 md:p-6-0 md:pt-4-0 bg-white">
            <Logo
              type={2}
              className="flex justify-center mx-auto h-15-0 my-6-0"
              disabledLink
            />
            <p className="font-bd text-2-4 leading-1-0 my-5-0">
              {t('global.welcome_to_agrantis')}
            </p>
            <Login redirectAfterLogin={handleLogin} />
          </div>
        </div>
      </div>
    </>
  );
}
